import { useContext, useEffect, useRef, useState } from 'react'
// import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import {
  GROUP_DONT_APPROVAL,
  GROUP_IS_ADMIN,
  GROUP_IS_HOST,
  GROUP_REQUESTING_APPROVAL,
} from '_utils/constant'
import { getGroupIdSelected, getUserInfo, setGroupIdSelected } from '_utils/localData'
// import { getGroupById } from '_redux/modules/group'
import { SelectIdGroupContext } from '_context/SelectGroupContext'

const PENDING_APPROVALS = [GROUP_DONT_APPROVAL, GROUP_REQUESTING_APPROVAL]

export default function useGroupManagement() {
  const userInfo = getUserInfo()
  const history = useHistory()
  // const dispatch = useDispatch()
  const { setInfoGroupSelected, infoGroupSelected } = useContext(SelectIdGroupContext)
  const [myGroups] = useState([...(userInfo?.groups || [])])
  const [isGroupDropdownOpen, setIsGroupDropdownOpen] = useState(false)
  const groupMenuRef = useRef(null)

  const listGroupWithAdmin = myGroups?.filter(
    (item) =>
      !PENDING_APPROVALS.includes(item?.approval) &&
      (item.isHost === GROUP_IS_HOST || item.isAdmin === GROUP_IS_ADMIN)
  )

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (groupMenuRef.current && !groupMenuRef.current.contains(e.target)) {
        setIsGroupDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelectGroupValue = (gid) => {
    const groupSelected = listGroupWithAdmin?.filter((group) => group.gid === gid)[0]
    if (!groupSelected) return

    setGroupIdSelected(groupSelected.gid)
    setInfoGroupSelected({
      groupId: groupSelected.gid,
      groupName: groupSelected.name,
      totalMembers: groupSelected.totalMembers,
      photoUrl: groupSelected.photoUrl,
    })

    // if (groupSelected.gid) dispatch(getGroupById(groupSelected.gid))

    const currentPath = history.location.pathname
    if (currentPath.includes('/event/manage-orders')) {
      history.push('/event/list-hosted-by-group')
    } else if (currentPath.includes('/event/manage-delivery')) {
      history.push('/event/delivery-list')
    } else if (currentPath.includes('/members/member-detail')) {
      history.push('/members')
    } else if (/\/manage-orders\/list-\d+$/.test(currentPath)) {
      history.push('/manage-orders')
    }
  }

  const groupInitial = infoGroupSelected?.groupName
    ? infoGroupSelected.groupName.charAt(0).toUpperCase()
    : 'G'

  return {
    myGroups,
    listGroupWithAdmin,
    infoGroupSelected,
    groupInitial,
    isGroupDropdownOpen,
    setIsGroupDropdownOpen,
    groupMenuRef,
    handleSelectGroupValue,
    getGroupIdSelected,
  }
}
